// Token source for the platform `apiClient`. Backed by Cognito Hosted UI +
// PKCE (see ./auth) when a user pool is configured; a no-op in mock/dev mode
// where `getCurrentBearer` resolves to null and requests go out unauthenticated
// to the localStorage mock.
//
// The apiClient depends only on the four functions exported here, so the auth
// backend can be swapped without touching feature code.

import {
  getCurrentBearer,
  isAuthEnabled,
  refreshBearer,
  startLogin,
} from './auth/userManager';

// Manual override, primarily for tests and for callers that want to inject a
// token directly. When set, it takes precedence over the Cognito session.
let overrideToken: string | null = null;

export const getAccessToken = async (): Promise<string | null> => {
  if (overrideToken !== null) return overrideToken;
  return getCurrentBearer();
};

export const setAccessToken = (token: string | null) => {
  overrideToken = token;
};

export const refreshAccessToken = async (): Promise<string | null> => {
  if (overrideToken !== null) return overrideToken;
  return refreshBearer();
};

export const redirectToLogin = () => {
  // In mock/dev mode there is no login to redirect to — stay put so the app
  // keeps working against the local mock.
  if (!isAuthEnabled()) return;
  void startLogin();
};
